import React from 'react'
import { Helmet } from 'react-helmet'
import {Link, Redirect} from 'react-router-dom'
import HeaderTopImage from './HeaderTopImage'
import Footer from '../Footer/Footer';


export default class Jobs extends React.Component {
	render() {
		return (
			<>
      <Helmet>
        <title>Jobs
 - Grospick </title>
        <meta name="description" content="Grospick is a delivery company with a personal touch offering a huge range of services and locations. Grospick delivers anything from bread to fruits or even groceries, door to door and on-demand." />
        <meta property="og:title" content="Jobs - Grospick" />
        <meta property="og:image" content="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" />
        <meta property="og:image:secure_url" content="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" />
        <meta property="og:description" content="Grospick is a delivery company with a personal touch offering a huge range of services and locations. Grospick delivers anything from bread to fruits or even groceries, door to door and on-demand." />
        <meta property="og:url" content={`https://www.grospick.com/jobs`} />
        <meta property="og:site_name" content="Grospick" />
        <link rel="canonical" href="https://www.grospick.com/jobs" />
        <meta name="twitter:card" content="Grospick Jobs" />
        <meta name="twitter:description" content="Grospick is a delivery company with a personal touch offering a huge range of services and locations. Grospick delivers anything from bread to fruits or even groceries, door to door and on-demand." />
        <meta name="twitter:title" content="Jobs - Grospick" />
        <meta name="twitter:image" content="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" />
                    </Helmet>
			
			<HeaderTopImage titre="Jobs" destination="Home" />
		<div>
<div className="bg-light" style={{marginBottom:'0px'}}>
  <div className="container" style={{marginBottom:'0px'}}>
    <div className="row h-100 align-items-center py-5">
      <div className="col-lg-12">
        <h4 className="h4">Jobs at Grospick</h4>
        <p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
        At Grospick, we know that every detail counts. So whether it’s discovering the best people for the job or creating an inspiring place to work, with our ‘grow our own’ development programme, we take the time to get to know our people, encouraging and creating opportunities for them to progress quickly within our business.
<br /> <br />
We strive to create a positive, rewarding and unique business culture for everyone who walks through our doors.
        <br /></p>
      </div>
    </div>
  </div>
</div>

<div className="bg-white" style={{marginBottom:'0px', textAlign:'left'}}>
  <div className="container" style={{marginBottom:'0px'}}>
    <div className="row h-100 align-items-center py-4">
      <div className="col-lg-12">
        <h4 className="h4">Meet the family </h4>
        <p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
Our people are our greatest asset and every one of them is part of our family.
<br />
</p>
<br />
<h4 className="h4" style={{textAlign:'left'}}>Pay and benefits </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
We are as passionate about our people as we are our products. We offer the most competitive pay in the industry, with a bonus and commission scheme that recognises commitment and passion.
<br /> <br />
We reward hard work with a long list of benefits, including generous paid holiday allowance, pension plan, childcare vouchers, a cycle to work scheme, and that’s just for starters.
</p>
<br />

<h4 className="h4">Information or suggestions: </h4>
<p className="lead text-dark mb-0" style={{textAlign:'justify'}}>
For any additional information or suggestions on how the site works, please do not hesitate to contact us. 
<footer class="blockquote-footer">  Don't step out, just <cite title="Source Title">Grospick it</cite></footer></p>
<br />
<Link to="./contact" style={{textDecoration:'none', color:'#34918c'}}><a className="btn btn-light px-5 rounded-pill shadow-sm">Contact-us</a></Link>
      </div>
    </div>
    <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2"><img src="https://res.cloudinary.com/mhmd/image/upload/v1556834139/img-1_e25nvh.jpg" alt="" className="img-fluid mb-4 mb-lg-0" /></div>
  </div>
</div>
</div>
 <br /> <br />
        	<Footer />
			</>
		)
	}
}